import { createSlice } from "@reduxjs/toolkit";
import { i18nInitState, i18nSliceName } from ".";
import { i18nInitAction } from "./i18nInitAction";
import { i18nSelectAction } from "./i18nSelectAction";

const i18nReducer = createSlice({
  name: `${i18nSliceName}`,
  initialState: i18nInitState,
  extraReducers: (builder) => {
    builder
      .addCase(i18nInitAction.fulfilled, (state, action) => {
        state.languages = action.payload;
      })
      .addCase(i18nSelectAction.fulfilled, (state, action) => {
        state.language = action.payload.language;
        state.phrases = action.payload.phrases;
      });
  },
}).reducer;

export default i18nReducer;
